import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import type { Observable } from 'rxjs';

import { WidgetsService } from 'components/organisms/widgets-loader/widgets.service';
import { HTTP_ERROR_HANDLER_SERVICE } from 'src/services/http-error-handler/entities/const';
import type { IHttpErrorHandlerService } from 'src/services/http-error-handler/entities/types';

@Injectable({ providedIn: 'root' })
export class WysiwygViewResolverService {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly httpErrorHandlerService = inject<IHttpErrorHandlerService>(HTTP_ERROR_HANDLER_SERVICE);
    private readonly widgetsService = inject(WidgetsService);

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | [] {
        this.widgetsService.markNoWidgets();
        return Promise.resolve([]);
    }
}
